module.exports = __webpack_public_path__ + "img/peal.cf5a2883.png";